import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByAsc, orderByDsc } from './format'


export function newIncome(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_INCOME_START", payload: "" })
            console.log("new Income START", {data})
            const res = await axios.post('/incomes/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_INCOME_ERROR", dispatch) ){                
				dispatch({ type: "NEW_INCOME", payload: res.data })
				dispatch({ type: "CREATE_INCOME_FULFILLED", payload: "" })
                
                if (res.data.income_facture_id) {
                    dispatch({ type: "UPDATE_FACTURE_REST", payload: res.data})

                }
			}
        } catch(err) {
            console.log("[ERROR] new income ", err);
            dispatch({
                type: "CREATE_INCOME_ERROR",
                payload: err
            })
        }
    }
}

export function fetchIncomes() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_INCOMES_START", payload: "" })
            
            console.log("fetch Income START")
            const res = await axios.get('/incomes/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_INCOMES_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_INCOMES",
                    payload: formatList(orderByDsc(res.data, "income_creation_date"), "income_id")
                })
                dispatch({ type: "FETCH_INCOMES_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get incomes list ", err);
            dispatch({ type: "FETCH_INCOMES_ERROR", payload: err })
        }
    }
}
export function fetchIncomePayments(income_id) {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_INCOME_PAYMENTS_START", payload: "" })
            
            console.log("fetch Income START")
            const res = await axios.post('/incomes/get/payments/list', {income_id})
            console.log({res});
            
            if (checkErrorData(res, "FETCH_INCOME_PAYMENTS_ERROR", dispatch) ){ 
                dispatch({
                    type: "UPDATE_INCOME_PAYMENTS",
                    payload: {list: res.data, income_id}
                })
                dispatch({ type: "FETCH_INCOME_PAYMENTS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get incomes list ", err);
            dispatch({ type: "FETCH_INCOME_PAYMENTS_ERROR", payload: err })
        }
    }
}


export function updateIncome(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_INCOME_START", payload: "" })
            
            console.log("update Income START")
            const res = await axios.post("/incomes/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_INCOME_ERROR", dispatch) ){  
                
				dispatch({
                    type: "UPDATE_INCOME",
                    payload: data
                })
				dispatch({ type: "UPDATE_INCOME_FULFILLED", payload: "" })
                // if (res.data.income_facture_id) {
                //     dispatch({ type: "UPDATE_FACTURE_REST", payload: data })

                // }
			}
        } catch(err) {
            console.log("[ERROR] update income ", err);
            dispatch({
                type: "UPDATE_INCOME_ERROR",
                payload: err
                
            })
        }
    }
}

export function deleteIncome(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_INCOME_START", payload: "" })

            console.log("delete income START")
            const res = await axios.post("/incomes/delete", {data: data.income_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_INCOME_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_INCOME",
                    payload: data,
                })
                dispatch({ type: "DELETE_INCOME_FULFILLED", payload: "" })
                if (data.income_facture_id) {
                    dispatch({ type: "UPDATE_FACTURE_REST", payload: data })

                }
            }

        } catch(err) {
            console.log("[ERROR] delete income ", err);
            dispatch({
                type: "DELETE_INCOME_ERROR",
                payload: err
            })
        }
    }
}

export function newPost(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_POST_START", payload: "" })
            console.log("new Post START", {data})
            const res = await axios.post('/incomes/posts/new',{data})
            console.log({res});

            if (checkErrorData(res, "CREATE_POST_ERROR", dispatch) ){                
                dispatch({ type: "NEW_POST", payload: res.data })
                dispatch({ type: "CREATE_POST_FULFILLED", payload: "" })
            }
        } catch(err) {
            console.log("[ERROR] new post ", err);
            dispatch({
                type: "CREATE_POST_ERROR",
                payload: err
            })
        }
    }
}

export function fetchPosts() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_POSTS_START", payload: "" })
            
            console.log("fetch Post START")
            const res = await axios.get('/incomes/posts/get/all')
            console.log({res});
            
            if (checkErrorData(res, "FETCH_POSTS_ERROR", dispatch) ){ 
                dispatch({
                    type: "GET_POSTS",
                    payload: formatList(orderByAsc(res.data, "post_name"), "post_id")
                })
                dispatch({ type: "FETCH_POSTS_FULFILLED", payload: "" })
            } 
        } catch(err) {
            console.log("[ERROR] get posts list ", err);
            dispatch({ type: "FETCH_POSTS_ERROR", payload: err })
        }
    }
}

export function updatePost(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_POST_START", payload: "" })

            console.log("update Post START")
            const res = await axios.post("/incomes/posts/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_POST_ERROR", dispatch ) ) {               
                // data.post_name = capitalizeWord(data.post_name)
				dispatch({
                    type: "UPDATE_POST",
                    payload: data
                })
				dispatch({ type: "UPDATE_POST_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update post ", err);
            dispatch({
                type: "UPDATE_POST_ERROR",
                payload: err
                
            })
        }
    }
}

export function deletePost(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_POST_START", payload: "" })

            console.log("delete post START")
            const res = await axios.post("/incomes/posts/delete", {data: data.post_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_POST_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_POST",
                    payload: data,
                })
                dispatch({ type: "DELETE_POST_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete income ", err);
            dispatch({
                type: "DELETE_POST_ERROR",
                payload: err
            })
        }
    }
}

export function importIncomes(incomes) {
    return async function(dispatch) {
        try {
            dispatch({ type: "IMPORT_INCOMES_START", payload: "" })
            console.log("import Incomes START", { incomes: incomes.length })
            const res = await axios.post('/incomes/import', { data: { incomes } })
            console.log({res});

            if (checkErrorData(res, "IMPORT_INCOMES_ERROR", dispatch)) {
                dispatch({ type: "IMPORT_INCOMES_FULFILLED", payload: res.data })
                return res.data; // { created, created_ids, failed_at_row, errors }
            }
            return null;
        } catch(err) {
            console.log("[ERROR] import incomes ", err);
            dispatch({ type: "IMPORT_INCOMES_ERROR", payload: err })
            throw err;
        }
    }
}
